module.exports = __webpack_public_path__ + "static/media/291776.f11f227d.png";